import axios from "axios";
import appConfig from "../config/api.config";

const base = appConfig.BASE_URL;
const prefix = base ? `${base}/s1` : "/s1";

const request = axios.create({
  baseURL: prefix,
  withCredentials: true,
  transformResponse: [
    (response) => {
      if (response == null || response === "") return null;
      let parsed;
      try {
        parsed = JSON.parse(response);
      } catch {
        return response;
      }
      if (parsed.error) return parsed;
      return Object.prototype.hasOwnProperty.call(parsed, "data")
        ? parsed.data
        : parsed;
    },
  ],
  validateStatus: (status) => (status >= 200 && status < 300) || status === 204,
});

export default request;
